/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ProductsInputs */

const en__field_products = /** @type {(inputs: _Field_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshops`)
};

const de__field_products = /** @type {(inputs: _Field_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshops`)
};

/**
* | output |
* | --- |
* | "Workshops" |
*
* @param {_Field_ProductsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_products = /** @type {((inputs?: _Field_ProductsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ProductsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_products(inputs)
	return de__field_products(inputs)
});